module.exports = __webpack_public_path__ + "img/ii-2@2x.41d584d2.png";